export const MAX_TEST_AGENTS = 10

export const MAX_OUTPUT_FIELDS = 10

export const OUTPUT_TYPES = [
  'str', 'int', 'bool', 'float',
  'list[str]', 'list[int]', 'list[bool]', 'list[float]'
]

export function makeTestAgentSchema(validateName, tools = []) {
  return [
    {
      type: 'container',
      className: 'details',
      dir: 'row',
      gap: '1.6rem',
      opts: [
        {
          field: 'name',
          validator: validateName,
          title: 'Name',
          type: 'identifier',
          maxlength: 128,
          required: true,
          placeholder: 'agent_name',
          post_flush: true
        },
        {
          field: 'description',
          title: 'Description',
          type: 'text',
          maxlength: 512,
          required: true,
          placeholder: 'Describe what this agent does',
          post_flush: true
        }
      ]
    },
    {
      field: 'tools',
      className: 'tools-field',
      title: 'Tools',
      type: 'multiselect',
      items: [...new Set(tools)],
      small: true,
      placeholder: 'Select tools'
    },
    {
      field: 'pass_sources',
      type: 'checkbox',
      label: 'Pass sources to this agent'
    },
    {
      field: 'prompt',
      className: 'prompt-field',
      title: 'Prompt',
      type: 'textarea-kb',
      maxlength: 25,
      required: true,
      placeholder: 'Add a prompt for this agent'
    },
    {
      field: 'output',
      type: 'output'
    },
  ]
}

export function makeOutputFieldSchema(validateName) {
  return [
    {
      field: 'name',
      title: 'Field name',
      type: 'text',
      placeholder: 'Field name',
      validator: validateName,
      required: true,
      post_flush: true,
      maxlength: 128
    },
    {
      field: 'type',
      title: 'Type',
      type: 'dropdown',
      items: OUTPUT_TYPES.map(value => ({value, title: value})),
      required: true,
      placeholder: 'Select type'
    },
    {
      field: 'description',
      title: 'Description',
      type: 'textarea',
      placeholder: 'Describe this output field',
      maxlength: 512,
      validator: value => value.length <= 512,
      rows: 3
    },
    {
      field: 'optional',
      type: 'checkbox',
      label: 'Optional'
    }
  ]
}
